export const surgeonSteps = [
  {
    element: '#surgeonsearch',
    popover: {
      title: 'Search Providers',
      showButtons: ['next', 'close'],
      description:
        '<div> Use the search bar (name/email/phone) to locate a specific provider quickly.</div>',
    },
  },
  {
    element: '#surgeonview',
    popover: {
      title: 'View Provider Details',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div> <li>The table shows each provider’s Name, Email, Phone, and Patient count.</li></div>',
      position: 'top',
    },
  },
  // {
  //     element: '#surgeonqr',
  //     popover: {
  //     title: 'Download QR Code',
  //     showButtons:['previous','next', 'close'],
  //     description: '<div><li>  Obtain a unique QR code for that surgeon.</li> </div>'
  //     },

  // },
  //  {
  //     element: '#surgeonpreview',
  //     popover: {
  //     title: 'View Surgeon Details',
  //     showButtons:['previous','next', 'close'],
  //     description: '<div><li>The table shows each surgeon’s Name, Email, Phone, and Patient count. </li></div>'
  //     },

  // },
  {
    element: '#sugeondelete',
    popover: {
      title: 'Delete Provider',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><li>Click DELETE to remove a selected provider.</li></div>',
    },
  },
  {
    element: '#sugeonadd',
    popover: {
      title: 'Add Provider',
      showButtons: ['previous', 'next', 'close'],
      description: '<div><li>Click ADD to register a new provider.</li></div>',
    },
  },
]
